import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, Fragment, useContext, useState, } from 'react';
import { Portal } from '@molecules/Portal';
const PortalContext = createContext(undefined);
export const PortalProvider = ({ children, }) => {
    const [items, setItems] = useState([]);
    const has = useCallback((id) => items.some((e) => e.id === id), [items]);
    const get = useCallback((id) => items.find((e) => e.id === id), [items]);
    const close = useCallback((portalId) => {
        var _a, _b;
        (_b = (_a = get(portalId)) === null || _a === void 0 ? void 0 : _a.onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        setItems((prev) => [...prev.filter(({ id }) => id !== portalId)]);
    }, [get]);
    const open = useCallback((element, options) => {
        setItems((prev) => [
            ...prev.filter(({ id }) => id !== options.id),
            Object.assign(Object.assign({}, options), { element }),
        ]);
    }, []);
    const value = {
        close,
        get,
        has,
        items,
        open,
    };
    return (_jsxs(PortalContext.Provider, { value: value, children: [children, _jsx(Portals, {})] }));
};
export const Portals = () => {
    const context = useContext(PortalContext);
    if (!context) {
        throw new Error('usePortals must be used within a PortalProvider');
    }
    const { items } = context;
    return (_jsx(Fragment, { children: items.map(({ id, element, type }) => (_jsx(Portal, { id: id, type: type, children: element }, id))) }));
};
export const usePortals = () => {
    const context = useContext(PortalContext);
    if (!context) {
        throw new Error('usePortals must be used within a PortalProvider');
    }
    return context;
};
